import { createI18n } from 'vue-i18n'
import es from '@/locales/es.json'
import en from '@/locales/en.json'

const SUPPORTED = ['es', 'en']

function detectInitialLocale() {
    // 1. Si ya hay sesión guardada en localStorage (prefix LC_), usar la persistida
    try {
        const stored = JSON.parse(localStorage.getItem('LC_authInfo') || '{}')
        if (stored && stored.idioma && SUPPORTED.includes(stored.idioma)) {
            return stored.idioma
        }
    } catch (e) { /* ignorar */ }

    // 2. Idioma del navegador
    const nav = (navigator.language || 'es').slice(0, 2)
    if (SUPPORTED.includes(nav)) return nav

    // 3. Default
    return 'es'
}

const i18n = createI18n({
    legacy: false,
    globalInjection: true,
    locale: detectInitialLocale(),
    fallbackLocale: 'es',
    messages: { es, en },
    silentTranslationWarn: true,
    silentFallbackWarn: true,
    missingWarn: false,
    fallbackWarn: false,
})

export function setLocale(locale) {
    if (!SUPPORTED.includes(locale)) return
    i18n.global.locale.value = locale
}

export const supportedLocales = SUPPORTED

export default i18n
